"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var wallet_1 = require("../../selector/wallet");
var wallet_2 = require("../../actions/wallet");
var wallets_1 = require("../../wallets");
var WalletButton = (function (_super) {
    __extends(WalletButton, _super);
    function WalletButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WalletButton.prototype.render = function () {
        var _this = this;
        return (React.createElement("button", { className: "HydroSDK-button HydroSDK-toggleButton", onClick: function () { return _this.handleClick(); } }, this.toggleText()));
    };
    WalletButton.prototype.handleClick = function () {
        var _a = this.props, isShowWalletModal = _a.isShowWalletModal, dispatch = _a.dispatch, notAllowClick = _a.notAllowClick;
        if (!notAllowClick) {
            dispatch(isShowWalletModal ? wallet_2.hideWalletModal() : wallet_2.showWalletModal());
        }
    };
    WalletButton.prototype.toggleText = function () {
        var _a = this.props, selectedAccount = _a.selectedAccount, walletTranslations = _a.walletTranslations;
        if (selectedAccount) {
            var isLocked = selectedAccount.get("isLocked");
            return (React.createElement("span", null,
                isLocked ? React.createElement("img", { src: 'https://jeongfront.s3-ap-northeast-1.amazonaws.com/lock.png', alt: "logo", width: '16px', height: '14px', style: {
                        marginTop: '-6px',
                        marginBottom: '-2px',
                        marginRight: '2px'
                    } }) : React.createElement("img", { src: 'https://jeongfront.s3-ap-northeast-1.amazonaws.com/check.png', alt: "logo", width: '16px', height: '14px', style: {
                        marginTop: '-6px',
                        marginBottom: '-2px',
                        marginRight: '2px'
                    } }),
                selectedAccount.get("address")
                    ? wallets_1.truncateAddress(JSON.stringify(selectedAccount.get("address")).replace('"', '').replace('"', '').slice(0, 2) === '0x' ?
                        JSON.stringify(selectedAccount.get("address")).replace('"', '').replace('"', '').slice(2) : JSON.stringify(selectedAccount.get("address")).replace('"', '').replace('"', '') || "")
                    : walletTranslations.toggleButtonText));
        }
        else {
            return React.createElement("span", null,
                " ",
                React.createElement("img", { src: 'https://jeongfront.s3-ap-northeast-1.amazonaws.com/lock.png', alt: "logo", width: '16px', height: '14px', style: {
                        marginTop: '-6px',
                        marginBottom: '-2px',
                        marginRight: '2px'
                    } }),
                walletTranslations.toggleButtonText);
        }
    };
    return WalletButton;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) {
    var walletState = state.WalletReducer;
    return {
        selectedAccount: wallet_1.getSelectedAccount(state),
        isShowWalletModal: walletState.get("isShowWalletModal"),
        walletTranslations: walletState.get("walletTranslations")
    };
})(WalletButton);
